import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import '../MasterTopButtons/MasterTopButtons.css';
import React from 'react'

const MasterTopButtons = ({ setOpenProfile, title, heading, setOpenAddProfile, openAddProfile, setFilterCityData, filterCityData, isEmployeeMasterPage, recordCount }) => {
  return (
    <div className="container-fluid" styel={{ marginTop: "3rem" }}>
      <div className="headerButton">
        <div>
          <button style={{ height: "53px", width: "101px" }} onClick={() => {
            setFilterCityData(!filterCityData);
            setOpenProfile(false);
            setOpenAddProfile(false);
          }}><FilterAltOutlinedIcon className="icon" />Filters</button>
        </div>
        <div className="button-container">
          <button
            onClick={() => {
              setOpenAddProfile(!openAddProfile);
              setOpenProfile(false);
              setFilterCityData(false);
            }}
          >
            <AddIcon className="icon" />{title}
          </button>

          {isEmployeeMasterPage ? (
            <button>Count: {recordCount}</button>
          ) : (
            <button>
              <DownloadIcon className="icon" />Download Excel
            </button>
          )}
        </div>
      </div>

      <hr />

      <div>
        <span style={{ fontSize: "25px" }}>{heading}</span>
      </div>
    </div>
  )
}

export default MasterTopButtons
